// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"Newsletter_formWrapper__DOwF6","form":"Newsletter_form__rIW9m","inputWrap":"Newsletter_inputWrap__dIKdw","icon":"Newsletter_icon__CTRvo"};